// lib/mock/support.ts
import type { Ticket } from "@/types";

export const MOCK_TICKETS: Ticket[] = [
  {
    id: "TK-2401-88472",
    subject: "مشکل در پرداخت آنلاین",
    customerName: "علی محمدی",
    priority: "high",
    status: "open",
    createdAt: Date.now() - 2 * 3600000,
    lastReply: "سلام، پرداخت من خطا داد ولی مبلغ کم شد.",
  },
  {
    id: "TK-2401-88470",
    subject: "درخواست مرجوعی کالا",
    customerName: "سارا احمدی",
    priority: "medium",
    status: "pending",
    createdAt: Date.now() - 1 * 86400000,
    lastReply: "لطفاً وضعیت مرجوعی من را بررسی کنید.",
  },
  {
    id: "TK-2401-88465",
    subject: "سؤال درباره ارسال",
    customerName: "رضا کریمی",
    priority: "low",
    status: "answered",
    createdAt: Date.now() - 2 * 86400000,
    lastReply: "ممنون از پاسخ شما.",
  },
  {
    id: "TK-2401-88460",
    subject: "کد تخفیف کار نمی‌کند",
    customerName: "مریم صادقی",
    priority: "medium",
    status: "open",
    createdAt: Date.now() - 3 * 86400000,
    lastReply: "کد SUMMER20 خطا می‌دهد.",
  },
  {
    id: "TK-2401-88452",
    subject: "تغییر آدرس تحویل",
    customerName: "حسین بیات",
    priority: "high",
    status: "closed",
    createdAt: Date.now() - 5 * 86400000,
    lastReply: "آدرس جدید ثبت شد.",
  },
];